const CircleIcon = () => {
  return (
    <svg width="100%" height="100%" focusable="false" viewBox="0 0 24 24" aria-hidden="true">
      <circle cx="12" cy="12" r="9"></circle>
    </svg>
  );
};

export default CircleIcon;
